import { SWRConfiguration } from 'swr';

import {
  AbsenceLimited,
  GET_USER_ABSENCE_LIMITED_SWR_KEY,
  getUserAbsenceLimited,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
};

export const useGetEmployeeAbsenceLimitedData = (
  props: PropsType,
  swrConfig?: SWRConfiguration<AbsenceLimited>,
): UseSWROutput<AbsenceLimited> => {
  const { employeeId } = props;

  return useSWR(
    [GET_USER_ABSENCE_LIMITED_SWR_KEY, employeeId],
    ([_, employeeId]) => getUserAbsenceLimited(employeeId),
    swrConfig,
  );
};
